// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import GlobalMethods from './globals'
import locale from 'view-design/dist/locale/fa-IR'
import 'view-design/dist/styles/iview.css'

Vue.config.productionTip = false
Vue.use(require('view-design'), { locale })

/* eslint-disable no-new */
Vue.mixin(GlobalMethods)

axios.defaults.baseURL = '/api'
Vue.use(VueAxios, axios)
Vue.mixin({
  data: function () {
    return {
      get BaseUrl () {
        return axios.defaults.baseURL
      }
    }
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js